/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import type SemeiaSessionService from "parog-web/services/session";

interface Signature {
  Args: {
    key: string;
    title: string;
    answers: number[];
  };
}
export default class extends Component<Signature> {
  @tracked isOpen = true;
  @service declare session: SemeiaSessionService;

  @action
  computeLabel(value: number): string | undefined {
    switch (value) {
      case 1:
        return "Presque jamais";
      case 2:
        return "Parfois";
      case 3:
        return "Souvent";
      case 4:
        return "Presque toujours";
      default:
        return undefined;
    }
  }

  get lower(): string[] {
    return [
      "nervous",
      "happinessOthers",
      "fail",
      "overcome",
      "overreact",
      "troubledThoughts",
      "equalTo",
      "ideasWithoutImportance",
      "disappointment",
      "preoccupied"
    ];
  }

  get upper(): string[] {
    return [
      "willingness",
      "happyMyself",
      "rested",
      "calm",
      "happy",
      "security",
      "decisions",
      "satisfaction",
      "solidNerves"
    ];
  }

  @action
  computeAnswer(key: string, value: number): number {
    if (this.lower.includes(key)) {
      return value;
    }
    return 5 - value;
  }
}
